import styled, { css } from 'styled-components';

export const Container = styled.section``;

export const Text = styled.p`
  font-weight: 400;
  font-size: 2rem;
  line-height: 3.6rem;
  margin: 0;

  strong {
    font-weight: 700;
  }
`;

export const CheckAppText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.primary100};
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.4rem;
  `}
`;

export const Button = styled.button`
  margin: 4px 0 0 0;
  padding: 4px 0;

  background: transparent;
  border: 0;

  cursor: pointer;
`;
